import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=25020bc9&scoped=true"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25020bc9",
  null
  
)

export default component.exports